import React, { useEffect } from 'react'
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const AgeCheck = () => {
    const profile = useSelector(state => state.userData.userProfile);
    const navigate = useNavigate();

    useEffect(() => {
        if (!profile) {return;}
        const now = new Date().getTime();
        const eighteenYrs = 31622400000 * 18
        if (profile.birthday > now - eighteenYrs) {
            navigate('/home/enrolled');
        }
    },[profile])

    return (
        <div></div>
    )
}

export default AgeCheck